<script>
import { skyColors } from '@/config'

export default {

  props: {
    timeOfDay: {
      type: String,
      default: 'noon',
      validator (timeOfDay) {
        return !!skyColors[timeOfDay]
      }
    }
  },

  computed: {

    color () {
      return skyColors[this.timeOfDay]
    }

  }

}
</script>

<template>
  <a-sky :color="color" />

  <!-- <a-simple-sun-sky
      :fog-color="fogColor"
      :light-color="lightColor"
      sun-position="0 0 0"
      radius="30000"
      dark-color="#00bfff"
    /> -->

  <!-- <a-simple-sun-sky
      sun-position="0 0 0"
      geometry
      material
    />

    <a-entity light="type: ambient; color: #BBB" />

    <a-entity
      light="type: directional; color: #FFF; intensity: 0.6"
      position="0.7 0.4 -1"
    /> -->

</template>
